<template>
  <div class="link-item-megamenu">
    <div @click="activate()">
      <slot name="linklevel2">link level</slot>
    </div>
    <div class="side-panel" :class="{ active: active }">
      <slot name="megamenuitem">megamenu item</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'itemmegamenu',
  data() {
    return {
      active: false,
    };
  },
  mounted() {
    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on('update.itemmegamenu', () => {
        this.active = false;

        /* istanbul ignore next */
        if (document.querySelectorAll('.block-with-img')) {
          const els = document.querySelectorAll('.block-with-img');
          Array.prototype.map.call(els, (obj) => {
            obj.style.display = 'block';
          });
        }
      });
    }
  },
  methods: {
    activate() {
      /* istanbul ignore next */
      if (window.eventBus) {
        window.eventBus.$emit('update.itemmegamenu', false);
      }
      if (!this.active) {
        this.active = true;

        /* istanbul ignore next */
        if (document.querySelectorAll('.block-with-img')) {
          const els = document.querySelectorAll('.block-with-img');
          Array.prototype.map.call(els, (obj) => {
            obj.style.display = 'none';
          });
        }
      }
    },
  },
};
</script>
